import {
  UNMET_REQUIREMENTS_STATUS,
  CANCELLED_INSURANCE_STATUSES,
} from '../hooks/useGetCoverageRequirements'

const coverageDataMatchesStatus = (data, matchesStatus) => {
  if (!Array.isArray(data) || data.length === 0) return false

  return data.some(item => {
    const status =
      item?.VerificationStatus ?? item?.accountStatusDetails?.VerificationStatus

    return matchesStatus(status)
  })
}

export const coverageQueriesHaveUnmetRequirements = queries => {
  for (const query of queries) {
    if (
      coverageDataMatchesStatus(
        query.data,
        status => status === UNMET_REQUIREMENTS_STATUS
      )
    ) {
      return true
    }
  }

  return false
}

export const coverageQueriesHaveCancelledInsurance = queries => {
  for (const query of queries) {
    if (
      coverageDataMatchesStatus(query.data, status =>
        CANCELLED_INSURANCE_STATUSES.includes(String(status ?? ''))
      )
    ) {
      return true
    }
  }

  return false
}
